define(["exports", "styled-components"], function (_exports, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);

  var IconStyles = _styledComponents.default.span.withConfig({
    displayName: "IconStyles",
    componentId: "sc-1vq750t-0"
  })(["display:block;height:16px;left:0;position:absolute;width:16px;box-icon{height:100%;margin:2px 0 0 0;width:100%;&[name='book']{fill:", ";}&[name='dollar-circle']{fill:", ";height:20px;width:20px;}&[name='building']{fill:", ";}&[name='map']{fill:", ";}}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.pink;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.green;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.darkBlue;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.yellow;
  });

  var _default = IconStyles;
  _exports.default = _default;
});